import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { createContact } from '../api/contacts';
import type { ContactFormValues } from '../types';

export function useCreateContact(onSuccess?: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ContactFormValues) => createContact(data),
    onSuccess: () => {
      invalidateListResource(queryClient, 'contacts');
      toast.success('Contact created');
      onSuccess?.();
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to create contact');
    },
  });
}
